'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useDragAndDrop } from './file-dropzone.hooks.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useRequiredI18nProps, getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { Typography } from '../typography/typography.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(o, e) {
    if (null == o) return {};
    var r, t, n = _object_without_properties_loose(o, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(o);
        for(t = 0; t < i.length; t++)r = i[t], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(o, r) && (n[r] = o[r]);
    }
    return n;
}
function _object_without_properties_loose(o, e) {
    if (null == o) return {};
    var r, t, n = {}, i = Object.keys(o);
    for(t = 0; t < i.length; t++)r = i[t], e.indexOf(r) >= 0 || (n[r] = o[r]);
    return n;
}
const FileDropzone = renderWithRef('FileDropzone', null, (n, h)=>{
    let b = useInternalOptionalSwanI18nContext();
    useRequiredI18nProps(n, [
        'note',
        'dropNote'
    ]), useComponentStylesLoaded('FileDropzone', SWAN_STYLE_KEY_MAP.fileDropzone), useDeprecatedProps('FileDropzone', n, [
        {
            propName: 'note',
            instructions: getDeprecatedI18nPropMessage(b)
        },
        {
            propName: 'dropNote',
            instructions: getDeprecatedI18nPropMessage(b)
        }
    ]);
    let { children: w, note: z, dropNote: y, multiFileErrorMessage: _ } = n, j = _object_without_properties(n, [
        "children",
        "note",
        "dropNote",
        "multiFileErrorMessage"
    ]), g = new Set([
        'swan-file-dropzone'
    ]), N = useRef(null), { isDragging: x, isMultiDropError: O } = useDragAndDrop(N);
    x && g.add('swan-file-dropzone-on-drag'), O && g.add('swan-file-dropzone-has-multi-file-error');
    let k = assignRefs(h, N), v = z, D = y;
    return b && !z && (v = b.t('file-dropzone.drag-and-drop-note')), b && !y && (D = b.t('file-dropzone.drop-note')), jsxs(RenderComp, {
        classNames: g,
        root: "div",
        forwardedRef: k,
        props: j,
        children: [
            w,
            jsx(Typography, {
                className: "swan-file-dropzone-note",
                children: v
            }),
            jsxs("div", {
                className: "swan-file-dropzone-drop-note",
                children: [
                    jsx(Icon, {
                        iconType: "add"
                    }),
                    jsx(Typography, {
                        fontSkin: "body-standard-bold",
                        children: D
                    })
                ]
            }),
            jsxs("div", {
                className: "swan-file-dropzone-error-message",
                children: [
                    jsx(Icon, {
                        iconType: "error"
                    }),
                    jsx(Typography, {
                        fontSkin: "body-standard-bold",
                        children: _
                    })
                ]
            })
        ]
    });
});

export { FileDropzone };
